import { BaseQueryKeys } from '@amzn/gsce-shared-react-lib';

/**
 * Query key constants for audit-related queries.
 *
 * Extends the shared lib's BaseQueryKeys pattern. createQuery and
 * createInfiniteQuery auto-map request params into the cache key as
 * [collectionName, params], so we only need the collection names here
 * for manual invalidation (e.g. after mutations).
 */
export class AuditQueryKeys extends BaseQueryKeys {
  /** Matches all audit list queries — use with queryClient.invalidateQueries */
  static readonly lists = 'audits' as const;
  /** Matches all audit detail queries */
  static readonly details = 'audit-detail' as const;
  /** Audit summary queries (metadata + questions) */
  static readonly summary = 'audit-summary' as const;
  /** Single audit question response queries */
  static readonly questionResponse = 'audit-question-response' as const;
  /**
   * All question responses for one audit, read from the primary
   * table (DynamoDB) rather than the eventually-consistent index the
   * summary endpoint uses. Authoritative source for response details
   * on the perform-audit page.
   */
  static readonly questionResponses = 'audit-question-responses' as const;
  /**
   * Sidecar cache: per-question `lastUpdatedAt` optimistic-concurrency
   * tokens keyed by auditId. Populated by the polling merger; read by
   * the update mutation to enrich `expectedLastUpdatedAt`.
   */
  static readonly responseTokens = 'audit-response-tokens' as const;
  /** Configured reason lists (NA_REASON, REOPEN_REASON, ...) scoped by BU + division */
  static readonly reasons = 'reasons' as const;
}
